import api_no_token_Service from "./api_no_token.service";

export interface CreateSessionRequest {
  amount: number;
  userId: number;
  accountId?: number | null;
  companyId?: number | null;
  packageDetailsId?: number | null;
}

export interface ProcessPaymentResultRequest {
  orderId: string;
  accountId?: number | null;
  companyId: number;
  packageDetailsId: number;
  resultIndicator?: string;
  sessionVersion?: string;
  checkoutVersion?: string;
}

export interface ProcessPaymentResultResponse {
  success: boolean;
}

export async function createSession(data: CreateSessionRequest) {
  const response = await api_no_token_Service.post(
    "/payment/createSession",
    data
  );
  return response;
}

export async function processPaymentResult(
  data: ProcessPaymentResultRequest
): Promise<ProcessPaymentResultResponse> {
  const response = await api_no_token_Service.post<ProcessPaymentResultResponse>(
    "/payment/processResult",
    data
  );
  
  console.log("Raw API response:", JSON.stringify(response, null, 2));
  
  // The backend returns { success: true/false }
  // api_no_token_Service.post returns ApiResponse<T> which has { data: T, success: boolean, message?: string }
  // So response.data should be { success: true/false }
  
  const result = response?.data;
  console.log("Extracted result:", JSON.stringify(result, null, 2));
  
  // Handle different response structures
  if (result && typeof result === 'object' && 'success' in result) {
    return { success: Boolean(result.success) };
  }
  
  // Fallback: check if response itself has success
  if (response && typeof response === 'object' && 'success' in response) {
    return { success: Boolean((response as any).success) };
  }
  
  return { success: false };
}

